import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import queryString from "query-string";

class MenuSubCategories extends Component {
  handleSubCategoryClick = (e, subName) => {
    const { category, location } = this.props;
    const parametros = queryString.parse(location.search);
    
    // If we are already on the productos page for this category, we scroll.
    if (location.pathname === "/productos" && parametros.categoria === category.nombre) {
      e.preventDefault();
      
      const elementId = `subcategoria-${subName.replace(/\s+/g, "-")}`;
      const element = document.getElementById(elementId);
      
      if (element) {
        const headerOffset = 230; // Adjusted for fixed header and banner
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        // Visual feedback immediately
        document.querySelectorAll(".subCategoriaLink").forEach(l => l.classList.remove("subCategoriaLinkP"));
        e.currentTarget.classList.add("subCategoriaLinkP");

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  };

  render() {
    const { category, location } = this.props;
    const parametros = queryString.parse(location.search);
    let subcategoriaSeleccionada = parametros.subcategoria;

    if (!category || !category.subCategorias || category.subCategorias.length === 0) {
      return null;
    }

    if (!subcategoriaSeleccionada) {
      subcategoriaSeleccionada = category.subCategorias[0].nombre;
    }

    return (
      <div className="menuSubCategorias">
        {category.subCategorias.map((sub) => (
          <Link
            key={sub.id}
            to={`/productos?categoria=${category.nombre}&subcategoria=${sub.nombre}`}
            className={
              "subCategoriaLink" +
              (subcategoriaSeleccionada === sub.nombre ? " subCategoriaLinkP" : "")
            }
            onClick={(e) => this.handleSubCategoryClick(e, sub.nombre)}
          >
            {sub.nombre}
          </Link>
        ))}
      </div>
    );
  }
}

export default withRouter(MenuSubCategories);
